import React from 'react';
import { ContentCards } from '@hz-design-system/web-ui';
import BlockSkeleton from '../Skeleton/BlockSkeleton';
import TextSkeleton from '../Skeleton/TextSkeleton';
import Classes from '../Skeleton/Skeleton.module.scss';

import FEED_ITEMS_PER_PAGE from '../../constants/feedItemsPerPage';

type TFeedItemListSkeleton = {
  itemsCount?: number;
};

const FeedItemListSkeleton = ({ itemsCount = FEED_ITEMS_PER_PAGE }: TFeedItemListSkeleton) => (
  <ContentCards kind="grid">
    {Array(itemsCount)
      .fill(true)
      .map((_, index) => (
        <div className={`hz-Card ${Classes.noShadow}`} key={index}>
          <article className={`hz-StructuredListing hz-StructuredListing--vertical ${Classes.noShadow}`}>
            <div className={`hz-Image hz-StructuredListing-image ${Classes.border}`}>
              <BlockSkeleton withAnimation={true} />
            </div>
            <div className="hz-Block">
              <div className="hz-StructuredListing-title">
                <TextSkeleton />
              </div>
              <div className="hz-StructuredListing-price">
                <TextSkeleton type="short" />
              </div>
            </div>
          </article>
        </div>
      ))}
  </ContentCards>
);

export default FeedItemListSkeleton;
